import React from 'react';
import {useTranslation} from 'react-i18next';
import {ProtectionInfo, ProtectionType} from '../../../../incase-domain/presentationProtection';
import ProtectionOptionsFormWrapper from './ProtectionOptionsFormWrapper';
import BulkInputEmailMultiselect from '../../../../ui/components/reactHookFormComponents/BulkEmailInputMultiselect';
import {Option} from '../../../../ui/components/common/MultiSelect';

interface SelectedUsersFormProps {
    protection: ProtectionInfo;
    setProtection: (protection: ProtectionInfo) => void;
    selectedAccounts?: {value: string; label: string}[];
}

function SelectedUsersForm({protection, setProtection, selectedAccounts}: SelectedUsersFormProps): JSX.Element {
    const {t} = useTranslation();

    const selectedUsersProtected = protection.types.includes(ProtectionType.SELECTED_USERS);

    const selectedUsers =
        protection.allowedUsers?.map((user) => ({
            value: user._id,
            label: user.email,
        })) ||
        selectedAccounts ||
        [];

    const setSelectedUsers = (options: Option[]): void => {
        setProtection({
            ...protection,
            allowedIds: options.map((option) => option.value),
            allowedUsers: options.map((option) => ({_id: option.value, email: option.label})),
        });
    };

    const handleAddSelectedConnections = (): void => {
        setProtection({
            ...protection,
            types: protection.types.filter((t) => t !== ProtectionType.REGISTERED_USERS).concat(ProtectionType.SELECTED_USERS),
        });
    };

    const handleRemoveSelectedConnections = (): void => {
        // if SELECTED_USERS is removed, also remove REGISTERED_USERS
        setProtection({
            ...protection,
            types: protection.types.filter((t) => t !== ProtectionType.SELECTED_USERS).concat(ProtectionType.REGISTERED_USERS),
            allowedIds: [],
            allowedUsers: [],
        });
    };

    return (
        <ProtectionOptionsFormWrapper
            // add count to localization if there are selected users
            label={t('presEditPage.settings.presProtection.selectedAccountsTrailingText', {count: selectedUsers.length})}
            checked={selectedUsersProtected}
            onToggle={selectedUsersProtected ? handleRemoveSelectedConnections : handleAddSelectedConnections}
        >
            <BulkInputEmailMultiselect
                defaultOptions={selectedUsers}
                placeholder={t('roomsPage.modals.searchUsers')}
                onChange={setSelectedUsers}
            />
        </ProtectionOptionsFormWrapper>
    );
}

export default SelectedUsersForm;
